export class RBConvert {
  /* converts a json string containing date in UTC format
     to a string with local date time */
  public static jsonUTCStringToString(json: string): string {
    if (json === null) {
      return '';
    }
    const date = new Date(json);
    return this.utcToString(date);
  }

  /* converts a UTC datetime value to a string
    with local timezone */
  public static utcToString(date: Date): string {
    if (date === null || date === undefined) {
      return '';
    }
    return (
      date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }) +
      ' ' +
      date.toLocaleTimeString(undefined)
    );
  }

  public static stringToBool(value: string): boolean {
    if (value == null) {
      return false;
    }
    const val = value.toUpperCase();
    return val.startsWith('T') || val.startsWith('Y');
  }

  public static booltoString(value: boolean): string {
    if (value) {
      return 'True';
    }
    return 'False';
  }
}
